import React from 'react';
import Component from '../../components/Component';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {RxForm, Form, FormField, FormManager} from 'reactis-forms';
import {FilterInput, DatePicker, Number, Select, SearchInput, Handsontable} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar,Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import {ModalWindow} from 'reactis-modal';
import Moment from 'moment';

export default class DayCell extends Component {

	constructor(props, context) {
		super(props);
	}

	render() {

		const {data} = this.props;

		const hours = data && data.hours && data.hours.map((part) => {
			if (part[0] == part[1]) {
				return part[0] + ' h';
			}
			return part[0] + ' - ' + part[1] + ' h';
		}).join(', ');

		return (
			<div className="daycell" onClick={() => this.props.onEditClick()} >
				{<div className="export"><span className="fa fa-pencil"></span></div>}
				<span style={{cursor:'pointer'}} className="day">
					{this.props.date.getDate()}. {this.props.compact && DbInfo.DayShort.get(new Moment(this.props.date).isoWeekday())}
				</span>
				{!this.props.compact && <br/>}
				<br/>
				{data &&
				<div style={{cursor: 'pointer'}}>
					<div>{hours}</div>
					<div>{data.notice}</div>
				</div>
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/DayCell.js